// extracted by mini-css-extract-plugin
module.exports = {"payImg":"payImg___72WuY","title":"title___1YvU9","tip":"tip___1_J8V","btn":"btn___a2ZL0"};